import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-coverage',
  templateUrl: './media-coverage.component.html',
  styleUrls: ['./media-coverage.component.css']
})
export class MediaCoverageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
